import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Mission } from '../components/Mission';
import { Issues } from '../components/Issues';
import { Stats } from '../components/Stats';
import { Board } from '../components/Board';
import { News } from '../components/News';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-white flex flex-col" data-id="element-209">
      <Navbar data-id="element-210" />

      <main className="flex-grow" data-id="element-211">
        <Hero data-id="element-212" />
        <Stats data-id="element-213" />
        <Mission data-id="element-214" />
        <Issues data-id="element-215" />

        {/* Mid-page Donate Anchor */}
        <div id="donate" className="scroll-mt-24" data-id="element-216"></div>

        <Board data-id="element-217" />
        <News data-id="element-218" />
        <FinalCTA data-id="element-219" />
      </main>

      <Footer data-id="element-220" />
    </div>;
}